// bao migrate skip
import * as ko from "knockout";
class RadioButtonsViewModel {
    TagViewModel = null;
    TagId: string = null;
    Parent: any = null;
    CboOptions = ko.observableArray<string>([]);
    TagTextValue;
    SelectedOption;
    constructor(shiftReportTagTab, tagId) {
        this.Parent = shiftReportTagTab;
        this.TagId = tagId;
        this.TagViewModel = this.Parent.getTagModel(this.TagId);
        this.CboOptions(this.TagViewModel.Options);
        this.TagTextValue = this.Parent.getTagObservable(this.TagId).TextValue;
        this.SelectedOption = ko.pureComputed({
            read: () => {
                return [ko.unwrap(this.TagTextValue)];
            },
            write: (val) => {
                if (val) {
                    this.TagTextValue(val[0]);
                }
            }
        });
    }
    init() {
    }
}
export default RadioButtonsViewModel;